/* unplugin-vue-components disabled */import script from "./TimeChangePage.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeChangePage.vue?vue&type=script&setup=true&lang=js"

import "./TimeChangePage.vue?vue&type=style&index=0&id=1ea5f454&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ea5f454"]])

export default __exports__